export default "__VITE_ASSET__rm_ZnN5A__"